import React from 'react';
import { TableRow, TableCell, TableBody } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';
import { useConfigService } from '@thd-nucleus/experience-context';
import { TableHeader } from './table-header';
export var PurchasingTableContent = function (_a) {
    var isEnrolled = _a.isEnrolled;
    var enablePHAPermissions = !!useConfigService('ENABLE_PHA_PERMISSIONS');
    return (React.createElement(React.Fragment, null,
        React.createElement(TableHeader, { title: "Purchasing", showRunner: isEnrolled }),
        React.createElement(TableBody, null,
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Purchase in-store"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                isEnrolled && (React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)))),
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Purchase online"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                isEnrolled && React.createElement(TableCell, { width: "full" })),
            enablePHAPermissions && (React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, "Manage Text-to-Confirm"),
                React.createElement(TableCell, { align: "center", width: "full" },
                    React.createElement(Checkmark, null)),
                React.createElement(TableCell, { width: "full" }),
                isEnrolled && React.createElement(TableCell, { width: "full" }))))));
};
